import { useState, useEffect, useRef } from "react";
import "./ServicesTimeline.css";
import serviceCategories from "../serviceData";

const MAX_DESCRIPTION = 120;

const truncate = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, limit).trim() + "...";
};

const ServicesTimeline = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const wrapperRef = useRef(null);

  // Close the popover when tapping/clicking outside a card
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setActiveIndex(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  const handleGetStarted = () => {
    window.location.href = "/quote";
  };

  return (
    <section className="servicesTimeline">

      <div className="timelineWrapper" ref={wrapperRef}>

        {serviceCategories.map((category, index) => {
          const isTruncated = category.description.length > MAX_DESCRIPTION;
          const isOpen = activeIndex === index;

          return (
            <div
              key={index}
              className={`timelineItem ${
                index % 2 === 0 ? "left" : "right"
              }`}
            >

              {/* Number */}

              <div className="timelineNumber">
                {index + 1}
              </div>

              {/* Card */}

              <div className="timelineCard">

                <h3>{category.title}</h3>

                <div className="timelineDescWrap">

                  <p
                    className={isTruncated ? "isTruncated" : ""}
                    onClick={() => isTruncated && setActiveIndex(isOpen ? null : index)}
                    onMouseEnter={() => isTruncated && setActiveIndex(index)}
                    onMouseLeave={() => isTruncated && setActiveIndex(null)}
                  >
                    {truncate(category.description, MAX_DESCRIPTION)}
                  </p>

                  {isTruncated && isOpen && (
                    <div className="timelinePopover">
                      {category.description}
                    </div>
                  )}

                </div>

                <ul>

                  {category.services.map((service, i) => (

                    <li key={i}>
                      {service.title}
                    </li>

                  ))}

                </ul>

              </div>

            </div>
          );
        })}

      </div>

      <div className="approach-cta">

            <p>Ready to bring your idea to life?</p>

            <button className="cta-button" onClick={handleGetStarted}>
            Get Started
            </button>

       </div>

    </section>
  );
};

export default ServicesTimeline;